export function isVersionC(fprVersion) {
    return [11].includes(parseInt(fprVersion));
}
